import { apiUrl } from './apiBase';
import { auth } from '../firebase';

const getActivePersonel = () => {
  try {
    const raw = localStorage.getItem('aktifPersonel');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

async function postAml(path, body) {
  const headers = { 'Content-Type': 'application/json' };
  const sharedSecret = String(process.env.REACT_APP_CAMPAIGN_AI_SHARED_SECRET || '').trim();
  if (sharedSecret) headers['x-ukba-internal-key'] = sharedSecret;
  try {
    const token = await auth.currentUser?.getIdToken?.();
    if (token) headers.Authorization = `Bearer ${token}`;
  } catch (_) {
    /* ignore */
  }
  const res = await fetch(apiUrl(path), {
    method: 'POST',
    headers,
    body: JSON.stringify({ ...(body || {}), personel: getActivePersonel() })
  });
  let data = {};
  try {
    data = await res.json();
  } catch (_) {
    data = {};
  }
  if (!res.ok || data?.ok === false || data?.success === false) {
    const err = new Error(data?.message || data?.error || `İstek başarısız (${res.status || '?'})`);
    err.code = data?.code;
    err.payload = data;
    throw err;
  }
  return data;
}

export const fetchAmlSettings = () => postAml('/api/aml/settings', {});
export const saveAmlSettingsApi = (settings) => postAml('/api/aml/settings', { settings });
export const fetchAmlSources = () => postAml('/api/aml/sources', {});
export const runAmlSyncNow = () => postAml('/api/aml/sync-now', {});
export const runAmlBackfill = (limitPerBranch) => postAml('/api/aml/backfill', { limitPerBranch });
export const submitAmlReviewDecision = (payload) => postAml('/api/aml/review-decision', payload);
export const fetchAmlReview = (sube, reviewId) => postAml('/api/aml/review', { sube, reviewId });
export const lookupAmlSubject = (payload) => postAml('/api/aml/lookup', payload);
